import React, { Fragment, useEffect, useState } from "react";
import propTypes from "prop-types";

import {
  api,
  IKmosGetAllocationsForLane,
  IKmosGetAllocationsForLaneResult,
} from "../../../../logic/api";

import { PagedDataView } from "../../../../components/lists/PagedDataView/PagedDataView";

import { formatDate } from "../../../../utility/utils";
import { ISessionState } from "../../../../utility/useSession";
import { useTranslation } from "react-i18next";

const KmosLaneAllocationList: React.FunctionComponent<{
  laneId: number;
  session: ISessionState;
}> = (props) => {
  const { t } = useTranslation();
  const [params, setParams] = useState<IKmosGetAllocationsForLane>({
    laneId: props.laneId,
  });

  useEffect(() => {
    if (props.laneId != params.laneId) {
      setParams({
        laneId: props.laneId,
      });
    }
  }, [props.laneId]);

  if (props.laneId == null) {
    return <Fragment></Fragment>;
  }
  return (
    <div>
      <PagedDataView<
        IKmosGetAllocationsForLane,
        IKmosGetAllocationsForLaneResult
      >
        apiHook={api.hooks.kmosV2.getAllocationsForLane}
        animate={false}
        parameters={params}
        header={(items) => {
          return (
            items &&
            items.data &&
            items.data.length > 0 && (
              <div style={{ textAlign: "center" }}>
                <span>{t("kmos.labels.allocatedTo")} </span>
                {items.data
                  .map(
                    (item) =>
                      `${formatDate(new Date(item.date), props.session)} ${item.name}`
                  )
                  .join(", ")}
              </div>
            )
          );
        }}
        renderItem={() => <></>}
      >
        <div style={{ textAlign: "center" }}>
          {t("input.validations.noExistingAllocationsLanes")}
        </div>
      </PagedDataView>
    </div>
  );
};

KmosLaneAllocationList.propTypes = {
  laneId: propTypes.number.isRequired,
};

export default KmosLaneAllocationList;
